/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The WebKeyIdBody model module.
 * @module model/WebKeyIdBody
 * @version 1.0.0
 */
export class WebKeyIdBody {
  /**
   * Constructs a new <code>WebKeyIdBody</code>.
   * @alias module:model/WebKeyIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>WebKeyIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WebKeyIdBody} obj Optional instance to populate.
   * @return {module:model/WebKeyIdBody} The populated <code>WebKeyIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new WebKeyIdBody();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} title
 */
WebKeyIdBody.prototype.title = undefined;

/**
 * @member {String} description
 */
WebKeyIdBody.prototype.description = undefined;

/**
 * @member {Boolean} enabled
 */
WebKeyIdBody.prototype.enabled = undefined;

